import { CATEGORIE_DISPOSITIF } from '@/configuration/catalogue/produitConf';
import getSupportCommercial from './getSupportCommercial';

export default async function genererProduitDispositif(sens) {
  const supportCommerical = await getSupportCommercial(CATEGORIE_DISPOSITIF);
  return {
    liaisonsTarif: [],
    disponibilite: 0,
    reference: '',
    libelle: '',
    tauxTva: 20,
    supportCommercialId: supportCommerical.id,
    supportCommercial: supportCommerical,
    schemaComptableId: null,
    schemaComptable: null,
    produitDispositif: {
      quantite: null,
      uniteVente: null,
      prixUnitaire: null,
      dispositifSupportId: null,
      dispositifTypeId: null,
      materielTypeId: null,
      materielFormatId: null,
      isDoubleFace: false,
      nomenclature: null,
      nomenclatureTypeId: null,
      eclaire: false,
    },
    tiersId: null,
    logisticable: true,
    compteAnalytiqueId: null,
    agenceId: null,
    controleDisponibilite: false,
    categorieGroupeProduitDeductibleId: null,
    sens: sens,
    categorieOperation: null,
    demandeInterventionTypes: [],
    commissionsVendeur: [],
    reglesAchat: [],
    commentaireVente: null,
    renouvelable: true,
  };
}
